export function getPath(obj, path, defaultValue) {
    if (!obj) {
        return defaultValue;
    }

    const _path = path.split(".");

    const item = _path.reduce((acm, key) => {
        if (!acm) {
            return;
        }

        if (acm[key]) {
            return acm[key];
        }
    }, obj);

    if (!item) {
        return defaultValue;
    }
    return item;
}
